"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = clientReducer;
exports.initialState = exports.ACTION_HANDLERS = exports.fetchClient = exports.CLIENT_FETCH_SUCCESS = exports.CLIENT_FETCH_ERROR = exports.CLIENT_FETCH = void 0;

var _Status = require("../../models/Status");

var _ACTION_HANDLERS;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ------------------------------------
// Constants
// ------------------------------------
var CLIENT_FETCH = 'CLIENT_FETCH';
exports.CLIENT_FETCH = CLIENT_FETCH;
var CLIENT_FETCH_ERROR = 'CLIENT_FETCH_ERROR';
exports.CLIENT_FETCH_ERROR = CLIENT_FETCH_ERROR;
var CLIENT_FETCH_SUCCESS = 'CLIENT_FETCH_SUCCESS'; // ------------------------------------
// Actions
// ------------------------------------

/**
 * Gets Clients
 */

exports.CLIENT_FETCH_SUCCESS = CLIENT_FETCH_SUCCESS;

var fetchClient = function fetchClient() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return {
    type: CLIENT_FETCH,
    identifier: 'client',
    payload: {
      query: query
    }
  };
}; // ------------------------------------
// Actions Handlers
// ------------------------------------


exports.fetchClient = fetchClient;
var ACTION_HANDLERS = (_ACTION_HANDLERS = {}, _defineProperty(_ACTION_HANDLERS, CLIENT_FETCH, function (state, action) {
  return _objectSpread({}, state, {
    status: new _Status.Status(_Status.States.LOADING)
  });
}), _defineProperty(_ACTION_HANDLERS, CLIENT_FETCH_SUCCESS, function (state, action) {
  var data = action.payload && action.payload.data ? action.payload.data : {};
  return _objectSpread({}, state, {}, data, {
    status: new _Status.Status(_Status.States.NORMAL)
  });
}), _defineProperty(_ACTION_HANDLERS, CLIENT_FETCH_ERROR, function (state, action) {
  return _objectSpread({}, state, {
    status: new _Status.Status(_Status.States.ERROR)
  });
}), _ACTION_HANDLERS); // ------------------------------------
// Reducer
// ------------------------------------

exports.ACTION_HANDLERS = ACTION_HANDLERS;
var initialState = {
  status: new _Status.Status()
};
exports.initialState = initialState;

function clientReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}